import { render, staticRenderFns } from "./WithdrawRequestsTable.vue?vue&type=template&id=16d1225c&lang=pug"
import script from "./WithdrawRequestsTable.vue?vue&type=script&lang=ts"
export * from "./WithdrawRequestsTable.vue?vue&type=script&lang=ts"
import style0 from "./WithdrawRequestsTable.vue?vue&type=style&index=0&id=16d1225c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
